<template>
  <Modal
    v-model="modal"
    :closable="false"
    :mask-closable="false"
    title="操作員日誌"
    width="90%"
    :styles="{ top: '10px' }"
  >
    <lida-table :propscolumns="columns" :data="items"></lida-table>
  </Modal>
</template>
<script>
export default {
  name: 'ModalLog',
  data () {
    return {
      modal: false,
      items: [],
      columns: {
        logdate: {
          title: "登录时间",
          key: "logdate",
          width: 150,
          align: "center"
        },
        browser: {
          title: "用户登录途径",
          key: "browser",
          align: "center"
        },
        ip: {
          title: "IP",
          key: "ip",
          width: 120,
          align: "center"
        },
        country: {
          title: "国家",
          width: 150,
          key: "country",
          align: "center"
        },
        outdate: {
          title: "登出时间",
          width: 150,
          key: "outdate",
          align: "center"
        },
        explain: {
          title: "登出原因",
          width: 100,
          key: "explain",
          align: "center"
        }
      }
    }
  },
  methods: {
    async getOperatorLog (id) {
      this.modal = true;
      try {
        const res = await this.$axios.operator.getOperatorLog(id)
        if ('status' in res && res.status === 0) return
        this.items = res
      } catch (error) {
        console.error(error);
      }
    }
  }
}
</script>